import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';

export default function ConditionsPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen pt-28 pb-20 bg-brand-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <span className="font-accent text-brand-gold text-sm tracking-[0.3em] uppercase">{t('footer.legal')}</span>
          <h1 className="font-heading text-4xl lg:text-5xl font-bold text-brand-black mt-2">{t('conditionsPage.title')}</h1>
          <p className="text-brand-dark/60 mt-4">{t('conditionsPage.subtitle')}</p>
        </motion.div>

        <div className="prose prose-gray max-w-none">
          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-8"
          >
            <div className="flex items-center gap-3 mb-4">
              <FileText className="h-6 w-6 text-brand-gold" />
              <h2 className="font-heading text-2xl text-brand-black m-0">1. {t('conditionsPage.section1')}</h2>
            </div>
            <p className="text-brand-dark/80">{t('conditionsPage.section1Text')}</p>
          </motion.section>

          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="mb-8"
          >
            <h2 className="font-heading text-2xl text-brand-black">2. {t('conditionsPage.section2')}</h2>
            <p className="text-brand-dark/80">{t('conditionsPage.section2Text')}</p>
          </motion.section>

          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 }}
            className="mb-8"
          >
            <h2 className="font-heading text-2xl text-brand-black">3. {t('conditionsPage.section3')}</h2>
            <p className="text-brand-dark/80">{t('conditionsPage.section3Text')}</p>
          </motion.section>

          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="mb-8"
          >
            <h2 className="font-heading text-2xl text-brand-black">4. {t('conditionsPage.section4')}</h2>
            <p className="text-brand-dark/80">{t('conditionsPage.section4Text')}</p>
          </motion.section>

          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25 }}
            className="mb-8"
          >
            <h2 className="font-heading text-2xl text-brand-black">5. {t('conditionsPage.section5')}</h2>
            <p className="text-brand-dark/80">{t('conditionsPage.section5Text')}</p>
          </motion.section>

          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="mb-8"
          >
            <h2 className="font-heading text-2xl text-brand-black">6. {t('conditionsPage.section6')}</h2>
            <p className="text-brand-dark/80">{t('conditionsPage.section6Text')}</p>
          </motion.section>

          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.35 }}
            className="mb-8"
          >
            <h2 className="font-heading text-2xl text-brand-black">7. {t('conditionsPage.section7')}</h2>
            <p className="text-brand-dark/80">{t('conditionsPage.section7Text')}</p>
            <ul className="text-brand-dark/80 list-none space-y-1 mt-2">
              <li><strong>Email:</strong> alinaelegance1@gmail.com</li>
              <li><strong>{t('contact.address')}:</strong> 130 Topham Terrace, Orléans, ON</li>
            </ul>
          </motion.section>
        </div>
      </div>
    </div>
  );
}
